import { Helmet } from "react-helmet";
import { useAppSelector } from "redux/hooks";

export function CookieConsent() {
  const appConfig = useAppSelector((state) => state.appConfig);

  const dataDomainScript =
    appConfig.environment === "prod"
      ? "01946608-815d-7c18-9603-d886d2e7413d"
      : "01946608-815d-7c18-9603-d886d2e7413d-test";

  return (
    <Helmet>
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-language="en"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script={dataDomainScript}
      ></script>
      <script type="text/javascript">
        function OptanonWrapper() &#123;&#125;
      </script>
    </Helmet>
  );
}
